import MuiIconButton, { IconButtonProps } from '@mui/material/IconButton';
import { FC } from 'react';
import { Icon, IconType } from 'atoms/Icon';
import { IconSVG, IconSvgType } from 'atoms/IconSVG';
import styles from './styles.module.css';

export const IconButton: FC<
  IconButtonProps & {
    iconType?: IconType;
    iconSvgType?: IconSvgType;
    iconClass?: string;
  }
> = ({ iconType, iconSvgType, iconClass, ...props }) => {
  const renderComponent = (props: { className?: string }) => {
    if (iconType) {
      return <Icon type={iconType} {...props} />;
    } else if (iconSvgType) {
      return <IconSVG type={iconSvgType} {...props} />;
    }
  };

  return (
    <MuiIconButton
      classes={{ root: styles.root }}
      {...props}
      data-testid={iconType || iconSvgType}
    >
      {renderComponent({ className: iconClass })}
    </MuiIconButton>
  );
};
